import React from 'react';
import {DateTime} from "luxon";
import {getHumanReadableDate} from "../../Helpers/DateTimeHelper";

const DateDivider = (props) => {
    let show = false;

    if (!props.previousDateTime) {
        show = true;
    } else {
        let date = DateTime.fromISO(props.dateTime);
        let previousDate = DateTime.fromISO(props.previousDateTime);
        if (!date.hasSame(previousDate, 'day')) {
            show = true;
        }
    }

    if (show) {
        return (
            <tbody className="date-row">
                <tr>
                    <th
                        className={`sticky-row ${(props.hasFilterRow) ? 'has-filter-row' : ''}`}
                        colSpan={props.colSpan}
                    >
                        <i className="fa fa-clock-o"></i>&nbsp;
                        {getHumanReadableDate(props.dateTime)}
                    </th>
                </tr>
            </tbody>
        );
    }

    return null;
}

export default DateDivider;

DateDivider.defaultProps = {
    colSpan: 7,
    hasFilterRow: false,
}
